import { Rule } from 'antd/es/form';
import { AppDatePicker, AppFormItemProps, AppFormRangeItem } from 'components/atoms';
import { DATE_LABEL } from 'consts/labels/common';
import { formFields } from 'consts/form/formFields';
import { formElementRequiredText } from 'consts/errors/forms';
import { childrenTexts } from 'consts/text';
import { AppFormRangeItemMode } from 'types';
import { datesTimelineValidator } from 'utils/validators';

export type AccountingPeriodDatePickerElementProps = AppFormItemProps & {
    mode: AppFormRangeItemMode;
};

export const AccountingPeriodDatePickerElement = ({
    mode,
    ...props
}: AccountingPeriodDatePickerElementProps) => {
    const rules: Rule[] = [
        { required: true, message: formElementRequiredText },
        ({ getFieldValue }) =>
            datesTimelineValidator(getFieldValue, {
                mode,
                startValueFieldName: formFields.accountingPeriodStartDate,
                finishValueFieldName: formFields.accountingPeriodFinishDate,
                isFinishValueBeforeStartValueErrorText:
                    childrenTexts.childForm.settlementData.settlementPeriodEndBeforeStart,
                isStartValueAfterFinishValueErrorText:
                    childrenTexts.childForm.settlementData.settlementPeriodStartAfterEnd,
                unitToCompare: 'day',
            }),
    ];

    return (
        <AppFormRangeItem
            mode={mode}
            startValues={{
                label: childrenTexts.childForm.settlementData.settlementPeriodStart,
                additionalText: DATE_LABEL,
                name: formFields.accountingPeriodStartDate,
                rules,
                accessibilityLabel: 'Pole data rozpoczęcia okresu rozliczeniowego',
            }}
            finishValues={{
                label: childrenTexts.childForm.settlementData.settlementPeriodEnd,
                additionalText: DATE_LABEL,
                name: formFields.accountingPeriodFinishDate,
                rules,
                accessibilityLabel: 'Pole data zakończenia okresu rozliczeniowego',
            }}
            {...props}
        >
            <AppDatePicker
                autoComplete="off"
                accessibilityLabel="Pole data"
                placeholder="Wybierz datę"
            />
        </AppFormRangeItem>
    );
};
